module.exports = __webpack_public_path__ + "img/tour-2.73c4c20b.svg";